//对于axios进行二次封装

import axios from 'axios'; //引入axios


//1:利用axios对象的方法create,去创建一个axios实例 
//2:request就是axios,只不过稍微配置一下 
const requests = axios.create({
    //配置对象
    baseURL: '/api', //基础路径,发请求的时候,路径当中会出现api
    timeout: 5000, //代表请求超时的时间5S
});


//请求拦截器
requests.interceptors.request.use((config) => {

    //携带token给服务器
    if(localStorage.getItem('TOKEN')) {
        config.headers.token = localStorage.getItem('TOKEN');
    }



    return config;
});


//响应拦截器  *注意起用此处，后端返回的token路径会少个data
// requests.interceptors.response.use((res) => {

//     return res.data
// }, (error) => {

// });




//对外暴露
export default requests;